import React, { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import { useAuth } from '../contexts/AuthContext';

export default function SupabaseTest() {
  const { user } = useAuth();
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function run() {
      console.log('[SupabaseTest] start', {
        supabaseUrl: process.env.REACT_APP_SUPABASE_URL,
        hasAnonKey: !!process.env.REACT_APP_SUPABASE_ANON_KEY,
        userId: user?.id,
      });

      try {
        const payload = {
          name: `Test client ${new Date().toISOString()}`,
          label: 'debug',
        };
        console.log('[SupabaseTest] inserting into clients', payload);

        const { data, error } = await supabase
          .from('clients')
          .insert(payload)
          .select();

        console.log('[SupabaseTest] insert result', { data, error });

        if (error) {
          setError(error.message);
        } else {
          setResult(data || null);
        }

        // Also test inserting into projects with a minimal payload
        const projectPayload = {
          title: `Debug project ${new Date().toISOString()}`,
          client_name: 'Debug client',
          status: 'open',
        };
        console.log('[SupabaseTest] inserting into projects', projectPayload);
        const { data: projData, error: projError } = await supabase
          .from('projects')
          .insert(projectPayload)
          .select();
        console.log('[SupabaseTest] projects insert result', { data: projData, error: projError });
      } catch (e) {
        console.error('[SupabaseTest] unexpected error', e);
        setError(e.message || 'Unexpected error');
      }
    }

    run();
  }, [user]);

  return (
    <div style={{ padding: '1.5rem' }}>
      <h1>Supabase connectivity test</h1>
      {!user && (
        <p style={{ color: 'red' }}>
          You are not logged in. Log in first, then reload this page.
        </p>
      )}
      {error && (
        <p style={{ color: 'red' }}>
          Error: {error}
        </p>
      )}
      {result && (
        <pre style={{ marginTop: '1rem', background: '#f3f4f6', padding: '1rem', borderRadius: 8 }}>
          {JSON.stringify(result, null, 2)}
        </pre>
      )}
      {!error && !result && (
        <p>Running test… check the browser console for detailed logs.</p>
      )}
    </div>
  );
}

